<template>
  <div class="myBill_user">

    <div class="pop">
      <el-dialog title="账单详情"
                 :visible.sync="dialogVisible"
                 width="500px">
        <div class="bill_list">
          <div class="bill_item">
            <span class="bill_title">账单号：</span>
            <span class="bill_centent">{{particularsData.payid}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">订单物流号：</span>
            <span class="bill_centent">{{particularsData.wlnum}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">订单ID：</span>
            <span class="bill_centent">{{particularsData.orderid}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">账单类型：</span>
            <span class="bill_centent">{{particularsData.fdtypename}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">账单时间：</span>
            <span class="bill_centent">{{common.formatDate(particularsData.createtime)}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">更新时间：</span>
            <span class="bill_centent">{{particularsData.endtime==0?'未更新':common.formatDate(particularsData.endtime)}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">收件人：</span>
            <span class="bill_centent">{{particularsData.sjname}}</span>
          </div>

          <div class="bill_item">
            <span class="bill_title">收件地址：</span>
            <span class="bill_centent">{{particularsData.sjgj+' '+particularsData.sjprovince+' '+particularsData.sjcity+' '+particularsData.sjaddress}}</span>
          </div>

          <div class="bill_item"
               style="width:100%">
            <span class="bill_title">账单备注：</span>
            <span class="bill_centent">{{particularsData.info}}</span>
          </div>

          <div class="bill_item"
               style="width:100%">
            <span class="bill_title">账单金额：</span>
            <span class="bill_centent"
                  style="font-weight: 700; color: #d00016;">{{particularsData.allprice}} CNY</span>
          </div>
        </div>

        <span slot="footer"
              class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <div class="myBill_top">
      <div class="top_item">
        <span>时间段查询</span>
        <el-date-picker v-model="time_inquire"
                        size="mini"
                        @change='selectTime'
                        type="daterange"
                        unlink-panels
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </div>

      <div class="top_item">
        <span>账单号查询</span>
        <el-input v-model="inquire.payid"
                  size="mini"
                  type="number"
                  @keyup.enter.native="getBillInfo"
                  placeholder="请输入账单号回车查询"></el-input>
      </div>

    </div>
    <div class="myBill_table">
      <el-table :data="billList"
                v-loading="loading"
                style="width: 100%"
                height="100%">
        <el-table-column label="账单时间"
                         width="200">
          <template slot-scope="scope">
            <span>{{common.formatDate(scope.row.createtime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payid"
                         label="账单号"
                         width="180">
        </el-table-column>
        <el-table-column label="物流单号"
                         width="170">
          <template slot-scope="scope">
            <span>{{scope.row.wlnum}}</span>
          </template>
        </el-table-column>
        <el-table-column label="账单状态"
                         width="120">
          <template slot="header"
                    slot-scope="scope">
            <el-dropdown @command="tabBillType($event,scope.row)">
              <span class="el-dropdown-link">
                {{selectedType}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in selectBillType"
                                  :key="item.value"
                                  :command="item">{{item.label}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 0?'warning': scope.row.status == 1?'info':scope.row.status==2?'success':'danger'">{{scope.row.status == 0?'未付款': scope.row.status == 1?'待审核':scope.row.status==2?'已付款':scope.row.status==3?'部分付款':'其他'}}</el-tag>
          </template>

        </el-table-column>
        <el-table-column label="账单类型"
                         width="120">
          <template slot-scope="scope">
            {{scope.row.fdtypename}}
          </template>
        </el-table-column>
        <el-table-column prop="sjname"
                         label="收件姓名/代码"
                         width="120">
        </el-table-column>
        <el-table-column label="账单金额（ CNY ）"
                         width="150">
          <template slot-scope="scope">
            <span class="parice_show"> {{scope.row.allprice}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address"
                         label="操作">
          <template slot="header"
                    slot-scope="scope">
            <div class="header_view">
              <el-input v-model="inquire.wlnum"
                        @keyup.enter.native="getBillInfo(scope.row)"
                        size="mini"
                        placeholder="输入物流号回车查询" />
              <el-button size="mini"
                         @click="reset_inquire">
                重置查询
              </el-button>
            </div>
          </template>

          <template slot-scope="scope">
            <div class="operationClass">
              <el-button size="mini"
                         @click="showParticulars(scope.row)">
                查看详情
              </el-button>
              <el-button size="mini"
                         v-if="scope.row.status<2"
                         @click="payment(scope.row.id,2)">
                支付
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="myBill_paging">
      <el-pagination background
                     layout="prev, pager, next"
                     :total="pageNumber"
                     :page-size='pageSize'
                     @current-change='tabPage'>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { apiBillInfo } from '@/request/api'
import common from '@/assets/js/common'
export default {

  name: 'myBill',
  data () {
    return {
      // -------选择的账单类型--------
      selectedType: '账单类型',
      // -------可选择的账单类型--------
      selectBillType: [
        {
          label: '全部',
          value: null
        },
        {
          label: '未付款',
          value: 0
        },
        {
          label: '待审核',
          value: 1
        },
        {
          label: '已付款',
          value: 2
        },
        {
          label: '已开票',
          value: 4
        },
      ],
      // -------选择的时间数组--------
      time_inquire: [],
      // -------详情数据--------
      particularsData: {},
      // -------显示详情--------
      dialogVisible: false,
      // -------公共方法--------
      common,
      // -------表格加载--------
      loading: false,
      // -------账单数据--------
      billList: [],
      // -------一共数量--------
      pageNumber: 0,
      // -------一页显示多少条数据--------
      pageSize: 12,
      // -------当前显示的页--------
      page: 1,
      // -------账单查询条件（具体参考文档）--------
      inquire: {
        status: '',
        fdtype: '',
        type: 1,
        bjid: '',
        wlnum: '',
        payid: '',
        orderid: '',
        zdtime: {
          start: '',
          end: ''
        }
      }
    }
  },
  methods: {
    // -------切换账单类型-------
    tabBillType (e) {
      this.page = 1
      this.selectedType = e.label
      this.inquire.status = e.value
      this.getBillInfo()
    },
    // -------选择筛选时间-------
    selectTime (e) {
      if (e) {
        this.page = 1
        this.inquire.zdtime.start = e[0]
        this.inquire.zdtime.end = e[1]
        this.getBillInfo()
      }

    },
    // -------切换页码--------
    tabPage (e) {
      this.page = e
      this.getBillInfo()
    },
    // -------显示详情--------
    showParticulars (row) {
      this.particularsData = row
      this.dialogVisible = true
    },
    //-------付款-------
    payment (id, is_order) {
      // console.log(id);
      this.$router.push({
        path: '/index/Payment',
        query: {
          id,
          order: is_order
        }
      })
    },
    // -------重置查询--------
    reset_inquire () {
      this.selectedType = '账单类型'
      this.inquire = {
        status: '',
        fdtype: '',
        type: 1,
        bjid: '',
        wlnum: '',
        payid: '',
        orderid: '',
        zdtime: {
          start: '',
          end: ''
        }
      }
      this.getBillInfo()
    },
    // -------获取账单信息--------
    async getBillInfo () {
      this.loading = true
      let res = await apiBillInfo({
        pd: 'getlist',
        pageSize: this.pageSize,
        page: this.page,
        status: this.inquire.status || null,
        fdtype: this.inquire.fdtype || null,
        bjid: this.inquire.bjid || null,
        wlnum: this.inquire.wlnum || null,
        payid: this.inquire.payid || null,
        orderid: this.inquire.orderid || null,
        zdtime: this.inquire.zdtime.start != '' && this.inquire.zdtime.end != '' ? JSON.stringify(this.inquire.zdtime) : null,
      })
      this.billList = res.orderlist
      if (res.errno == 0) {
        this.pageNumber = parseInt(res.totalNum, 10)
        this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
      this.loading = false
    }

  },
  computed: {

  },
  created () {
    this.getBillInfo()
  }
}
</script>

<style lang="scss">
.myBill_user {
  width: 100%;
  height: 100%;
  //   background-color: pink;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  box-sizing: border-box;
  .pop {
    .el-dialog__footer {
      text-align: center !important;
    }
    .bill_list {
      width: 100%;
      //   display: flex;
      flex-wrap: wrap;
      .bill_item {
        width: 100%;
        display: flex;
        margin-bottom: 15px;
        // flex-direction: column;
        .bill_title {
          width: 90px;
          color: #999;
        }
      }
    }
  }
  .myBill_top,
  .myBill_table,
  .myBill_paging {
    width: 95%;
    flex: 1;
    background-color: #fff;
    border-radius: 4px;
  }
  .myBill_top {
    max-height: 80px;
    min-height: 80px;
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    .top_item {
      min-width: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
      span {
        margin-bottom: 5px;
        color: #333;
        font-size: 14px;
      }
    }
  }
  .myBill_table {
    overflow: hidden;
    .el-dropdown-link {
      color: #999;
    }
    .parice_show {
      font-weight: 700;
      color: #d00016;
    }
    .operationClass {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .header_view {
      display: flex;
      .el-input__inner {
        border-right: 0;
        border-radius: 4px 0 0 4px !important;
      }
      .el-button {
        border-left: 0;
        border-radius: 0 4px 4px 0 !important;
      }
    }
  }
  .myBill_paging {
    max-height: 80px;
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>